module.exports = __webpack_public_path__ + "img/2.3b22d6c1.png";